import { Fragment } from 'react';
import Routers from './routes';
import Home from './Components/Pages/Home/home';
import Foot from './Components/Pages/Home/foot';
function App() {
  return (

    <Fragment>
      <Home />
      <Routers />
      <Foot />
    </Fragment>


  );
}

export default App;